import React from "react";
import { useElementOnScreen } from "@/hook/use-element-on-screen";
import LoadingIcon from "@/assets/icons/loading-icon";

interface Props extends React.PropsWithChildren {
  hasMore: boolean | undefined;
  loadMore: () => void;
  loading?: boolean;
  manualLoad?: boolean;
}

export const InfiniteLoader = ({
  hasMore,
  loadMore,
  loading = false,
  manualLoad = false,
  children,
}: Props) => {
  const targetRef = useElementOnScreen({
    enabled: !!hasMore,
    onScreen: () => {
      loadMore();
    },
    rootMargin: "30px",
    threshold: 0.2,
  });

  return (
    <>
      {children}
      {loading && (
        <div className="flex justify-center my-5">
          <LoadingIcon />
        </div>
      )}
      {hasMore && manualLoad && !loading && (
        <div className="flex justify-center my-2">
          <button onClick={loadMore} className="text-primary font-semibold">
            Show More
          </button>
        </div>
      )}
      {!manualLoad && (
        <span
          aria-label="bottom"
          ref={targetRef}
          style={{ visibility: "hidden" }}
        />
      )}
    </>
  );
};
